interface GetQuote {
  id: string;
  communityId: string;
  deductible: string;
  medicalPayments: string;
  personalPropertyCoverage: string;
  personalLiabilityCoverage: string;
  lossOfUse: string;
  theft: string;
  windHail: string;
  waterBackup?: string;
  petDamage?: string;
  identityFraud?: string;
  fireDepartmentService?: boolean;
  sinkHole?: boolean;
  ordinanceOrLaw?: boolean;
  rentalIncome?: boolean;
  workersCompensation?: boolean;
  earthquake?: number;
  hurricane?: number;
}

export const GET_QUOTE = (getQuote: GetQuote) => {
  let mutation = `mutation {
      getQuote(
        applicationId: "${getQuote.id}",
        input:{
          communityId: "${getQuote.communityId}",
          deductible: ${getQuote.deductible},
          medicalPayments: ${getQuote.medicalPayments},
          personalPropertyCoverage: ${getQuote.personalPropertyCoverage},
          personalLiabilityCoverage: ${getQuote.personalLiabilityCoverage},
          lossOfUse:${getQuote.lossOfUse},
          fireDepartmentService: ${getQuote.fireDepartmentService},
          sinkHole: ${getQuote.sinkHole},
          ordinanceOrLaw: ${getQuote.ordinanceOrLaw}, 
          rentalIncome: ${getQuote.rentalIncome},
          workersCompensation: ${getQuote.workersCompensation},
      `;
  if (getQuote.waterBackup) {
    mutation += `waterBackup:${getQuote.waterBackup},`;
  }
  if (getQuote.petDamage) {
    mutation += `petDamage:${getQuote.petDamage},`;
  }
  if (getQuote.identityFraud) {
    mutation += `identityFraud:${getQuote.identityFraud},`;
  }
  if (getQuote.theft) {
    mutation += `theft: ${getQuote.theft},`;
  }
  if (getQuote.windHail) {
    mutation += `windHail: ${getQuote.windHail},`;
  }
  if (getQuote.hurricane) {
    mutation += `hurricane: ${getQuote.hurricane},`;
  }
  if (getQuote.earthquake) {
    mutation += `earthquake: ${(getQuote.earthquake/5000).toFixed(2)}`;
  }
  mutation += `}
          ) {
              ... on ApplicationOutput {
                  id,
                  companyProductCd,
                  paymentPlans {
                      paymentPlanCd,
                      installmentAmount,
                      totalPremiumAmt,
                      installmentPaymentAmount,
                      installmentFeeAmount,
                      downPaymentAmount,
                      installmentAmount
                  }
              }
              ... on ErrorListOutput {
                  errors: errors {
                      type
                      message
                  }
              }
          }
      }`;
  return mutation;
};
